import { render, staticRenderFns } from "./Procurement.vue?vue&type=template&id=096cbca2&"
import script from "./Procurement.vue?vue&type=script&lang=js&"
export * from "./Procurement.vue?vue&type=script&lang=js&"
import style0 from "./Procurement.vue?vue&type=style&index=0&id=096cbca2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports